import React from "react";
import { useDispatch } from "react-redux";
import {
  userCleanSearchText,
  userSetSearchText,
  cleanSearchingUsersPaginated,
  startSearchingUsersPaginated,
  startLoadingUsersPaginated,
} from "../../app/actions/userActions";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackUser = ({ searchText, setSearchText, itemsPerPage, accessFilter }) => {

  debugLogPages(":: SearchBackUser");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchUsers", event: "SearchUsers-Clicked", search: event.target.value });

      dispatch(userSetSearchText(event.target.value));

      dispatch(startSearchingUsersPaginated(event.target.value, 0, itemsPerPage, accessFilter));
    } else {
      
      dispatch(cleanSearchingUsersPaginated());
      dispatch(userCleanSearchText());
      if (accessFilter) {
        dispatch(startLoadingUsersPaginated(0, itemsPerPage, accessFilter));
      }
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackUser;
